import Cell from './Cell'
import Row from './Row'

Row.Cell = Cell

export default Row



// WEBPACK FOOTER //
// ./src/components/Row/index.js